/**
 * @file   知识检索
 * @create macaiqi 2021/11/26
 * @update
 */
// import React, { useEffect, useRef, useState, useCallback } from 'react';
import React, { useState, useEffect, useCallback } from 'react';
import cls from 'classnames'
import { message } from 'antd';
// import { useHistory } from 'react-router-dom';
import { autoComplete, getRelationConfig,hotSpot } from '../../../shared/api';
import './index.scss'
const pre = window.ENV_IMG_PREURL_SRC;

const Search1 = ({ setFocus, endsearch, setEndsearch, startsearch, setStartsearch }) => {

  const [showauto1, setShowauto1] = useState(false)
  const [showauto, setShowauto] = useState(false)
  const [autolist, setAutolist] = useState()
  // const history = useHistory();
  const auto = (search) => {
    autoComplete(search).then((res) => {
      setAutolist(res)
    })
  }


  const onKeyDown1 = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        e.preventDefault();
        setShowauto1(false)
        setShowauto(false)
        if (startsearch && endsearch) {
          if (startsearch === endsearch) {
            message.error('请为起始节点和终点节点输入不同的关键词')
          } else {
            window.open(`/Relation?startsearch=${startsearch}&endsearch=${endsearch}`)
            // history.push({
            //   pathname: '/Relation',
            //   search: `startsearch=${startsearch}&endsearch=${endsearch}`
            // });
          }

        }
      }
    },
    [startsearch, endsearch]
  );
  return (
    <div className="searchipt1">
      <div className="searchbox">
        <input type="text" placeholder='输入起点节点名称或点击下方热点推荐' value={startsearch || ''}
          onKeyDown={onKeyDown1} onChange={(e) => {
            setStartsearch(e.target.value)
            setShowauto1(false)
            if (e.target.value) {
              setShowauto(true)
              auto(e.target.value)
            } else {
              setShowauto(false)
            }
          }}
          onFocus={() => {
            setFocus(1)
          }}
        />
        <ul className={cls('autolistul', { 'hide': !startsearch || !showauto })}>
          {(autolist?.length === 0 || !autolist) && <li>暂无相关信息，建议您更换节点或尝试热点推荐</li>}
          {autolist && autolist?.map((item, index) => {
            return (
              <li key={index} className='autolist' onClick={() => {
                setStartsearch(item)
                setShowauto(false)
                setShowauto1(false)
                if (endsearch) {
                  if (item === endsearch) {
                    message.error('请为起始节点和终点节点输入不同的关键词')
                  } else {
                    window.open(`/Relation?startsearch=${item}&endsearch=${endsearch}`)
                    // history.push({
                    //   pathname: '/Relation',
                    //   search: `startsearch=${item}&endsearch=${endsearch}`
                    // });
                  }

                }

              }}>
                {item}
              </li>
            )
          })}
        </ul>
      </div>
      <div className="change"
      // onClick={() => {
      //   setEndsearch(startsearch || '')
      //   setStartsearch(endsearch || '')
      // }}
      >
        <i className='iconfont' />
        <div className="hover">
          带你探寻两点之间的关系
        </div>
      </div>
      <div className="searchbox">
        <input type="text" placeholder='输入起点节点名称或点击下方热点推荐' value={endsearch || ''}
          onKeyDown={onKeyDown1} onChange={(e) => {
            setEndsearch(e.target.value)
            setShowauto(false)
            if (e.target.value) {
              setShowauto1(true)
              auto(e.target.value)
            } else {
              setShowauto1(false)
            }
          }}
          onFocus={() => {
            setFocus(2)
          }}
        />
        <ul className={cls('autolistul', { 'hide': !endsearch || !showauto1 })}>
          {(autolist?.length === 0 || !autolist) && <li>暂无相关信息，建议您更换节点或尝试热点推荐</li>}
          {autolist && autolist?.map((item, index) => {
            return (
              <li key={index} className='autolist' onClick={() => {
                setEndsearch(item)
                setShowauto(false)
                setShowauto1(false)
                if (startsearch) {
                  if (startsearch === item) {
                    message.error('请为起始节点和终点节点输入不同的关键词')
                  } else {
                    window.open(`/Relation?startsearch=${startsearch}&endsearch=${item}`)
                    // history.push({
                    //   pathname: '/Relation',
                    //   search: `startsearch=${startsearch}&endsearch=${item}`
                    // });
                  }

                }

              }}>
                {item}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
// 第一部分
const Top = ({ searchtype, setSearchtype, setFocus, endsearch, setEndsearch, startsearch, setStartsearch }) => {
  const [centersearch, setCentersearch] = useState()

  const [autolist, setAutolist] = useState()
  const [showauto, setShowauto] = useState(false)
  useEffect(() => {
    setShowauto(true)
    autoComplete(centersearch).then((res) => {
      setAutolist(res)
    })
  }, [centersearch])
  // const history = useHistory();
  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        e.preventDefault();
        setShowauto(false)
        window.open(`/Relation?centersearch=${centersearch}`)
        // history.push({
        //   pathname: '/Relation',
        //   search: `centersearch=${centersearch}`
        // });

      }
    },
    [centersearch]
  );

  return (
    <div className="top">
      <div className="box">
        <div className="top-c">
          <div className={cls('c ', { active: searchtype === 0 })} onClick={() => {
            setSearchtype(0)
            setAutolist(false)
          }}>
            中心节点检索
            <i className='iconfont icon-guanxijiansuo' />
          </div>
          <div className={cls('c ', { active: searchtype === 1 })} onClick={() => {
            setSearchtype(1)
            setAutolist(false)

          }}>
            关系路径检索
            <i className='iconfont icon-zhishijiansuo' />
          </div>
        </div>
        {searchtype === 0 && <div className="searchipt">
          <input type="text" placeholder='输入中心节点名称或点击下方热点推荐' value={centersearch || ''} className='search1' onChange={(e) => { setCentersearch(e.target.value) }} onKeyDown={handleKeyDown} />
          <ul className={cls('autolistul', { 'hide': !centersearch || !showauto })}>
            {(autolist?.length === 0 || !autolist) && <li>暂无相关信息，建议您更换节点或尝试热点推荐</li>}
            {autolist && autolist?.map((item, index) => {
              return (
                <li key={index} className='autolist' onClick={() => {
                  setCentersearch(item)
                  setShowauto(false)
                  window.open(`/Relation?centersearch=${item}`)
                  // history.push({
                  //   pathname: '/Relation',
                  //   search: `centersearch=${item}`
                  // });
                }}>
                  {item}
                </li>
              )
            })}
          </ul>
        </div>}
        {
          searchtype === 1 && <Search1
            setFocus={setFocus}
            endsearch={endsearch}
            setEndsearch={setEndsearch}
            startsearch={startsearch}
            setStartsearch={setStartsearch}
          />
        }

      </div>
    </div>
  )
}


// 首页
const KnowledgeRetrieval = () => {
  const [startsearch, setStartsearch] = useState()
  const [endsearch, setEndsearch] = useState()
  const [searchtype, setSearchtype] = useState() // 0中心节点检索 1关系路径检索
  const [focus, setFocus] = useState(1) // 关系路径检索的时候停留的文本框 1起始搜索 2终点搜索 初始为起始
  const [data, setData] = useState() // 热点推荐
  const [data1, setData1] = useState() // 中心节点检索-热点推荐
  const [data2, setData2] = useState() // 关系路径检索-热点推荐
  const [showdata, setShowData] = useState() // 热点推荐显示
  useEffect(() => {
    // 获取底部关系图谱数据
    getRelationConfig().then(res => {
      setData1(res.data?.datas1);
      setData2(res.data?.datas2);
      setSearchtype(0);
    })
    // // 热点推荐
    // hotSpot().then(res => {
    //   setData(res.data)
    //   setShowData(res.data?.defaultList)
    // })
  }, [])

  useEffect(() => {
    if (searchtype == 0) {
      setShowData(data1);
    }else{
      setShowData(data2);
    }
  }, [searchtype])
  // useEffect(() => {
  //   if (data?.default?.includes(startsearch)) {
  //     setShowData(data?.[startsearch])
  //   }
  //   if (data?.default?.includes(endsearch)) {
  //     setShowData(data?.[endsearch])
  //   }
  // }, [startsearch, endsearch, data])
  // const history = useHistory()
  return (<div className="knowledge-retrieval" >
    <Top data={data} searchtype={searchtype} setSearchtype={setSearchtype} setFocus={setFocus} endsearch={endsearch} setEndsearch={setEndsearch} startsearch={startsearch} setStartsearch={setStartsearch} />
    <div className="allcenter">
      <div className="content1">
        <div className="bigtitle">
          热点推荐
        </div>
        <div className='gxtp'>
          {showdata?.map((item, index) => {
            return (
              <div key={index}  onClick={() => {
                if (searchtype === 0) {
                  // 关系路径点击
                  window.open(`/Relation?centersearch=${item.title}`)
                }else{
                  window.open(`/Relation?startsearch=${item.title}&endsearch=${item.title1}`);
                }
              }}>
                <div className='css-bvybze portal-picture img'>
                  <img src={pre+item?.showImage?.replace('300@x','600@x')} alt='' />
                </div>
                <div className='text'>
                  <p className="title">{searchtype === 0 ? item.title : item.title+' -> '+item.title1}</p>
                  <p className="desc">{item.desc}</p>
                </div>
              </div>
            )
          })}
        </div>
        {/* <div className="data">
          {showdata?.map((item, index) => {
            return (
              <div className="item" key={index} onClick={() => {
                if (searchtype === 0) {
                  // 关系路径点击
                  window.open(`/Relation?centersearch=${item.name}`)
                }
                if (searchtype === 1) {
                  // 中心节点点击
                  if (focus === 1) {
                    // 左边聚焦点击后
                    if (endsearch) {
                      if (endsearch === item.name) {
                        message.error('请为起始节点和终点节点输入不同的关键词')
                      } else {
                        window.open(`/Relation?startsearch=${item.name}&endsearch=${endsearch}`)
                      }
                    } else {
                      setStartsearch(item.name)
                    }
                  }
                  if (focus === 2) {
                    // 右边聚焦点击后
                    if (startsearch) {
                      if (startsearch === item.name) {
                        message.error('请为起始节点和终点节点输入不同的关键词')
                      } else {
                        window.open(`/Relation?startsearch=${startsearch}&endsearch=${item.name}`)
                      }

                    } else {
                      setEndsearch(item.name)
                    }
                  }
                }

              }}>
                <div className="img">
                  {item.filePath ? <Picture source={item.filePath} /> : <img src={Default} alt="" />}
                </div>
                <p className="name">{item.name}</p>
              </div>
            )
          })}
        </div> */}
      </div>


    </div>
  </div>)
};

export default KnowledgeRetrieval;
